import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}/ReportingFollowUp`;

const post = async (path, body, token) => {
    const response = await fetch(`${API_URL}/${path}`, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP ${response.status}`);
    }
    return response.json();
};

/** Tracking entries, section periods, withholding books figures and file numbers for a report month. */
const getPeriodData = ({ caseId, year, month }, token) =>
    post('GetPeriodData', { caseId, year, month }, token);

/** Upserts the section entries and the month's material-received date and fee balance; returns fresh period data. */
const save = ({ caseId, year, month, materialReceivedDate, outstandingFeeBalance, entries }, token) =>
    post('Save', { caseId, year, month, materialReceivedDate, outstandingFeeBalance, entries }, token);

/** Excess deductions of the tax year's advance periods before the report month: `{ books, reported, periods, reportedPeriods }`. */
const getPriorExcessDeductions = ({ caseId, year, month, partnerId = null }, token) =>
    post('GetPriorExcessDeductions', { caseId, year, month, partnerId }, token);

/** Client page National Insurance panel amounts: `{ personalCurrentPayment, niWithholdingToPay, withholdingReportedToPay, ... }`. */
const getNationalInsuranceSummary = ({ caseId, year, month }, token) =>
    post('GetNationalInsuranceSummary', { caseId, year, month }, token);

/** Per-case section statuses of a report month for the accountant's cases (all of them when `caseIds` is empty). */
const getOverview = ({ accountantId, year, month, caseIds }, token) =>
    post('GetOverview', { accountantId, year, month, caseIds }, token);

/** Applies the given tracking fields to `sections` of every case in `caseIds`; null fields are left as they are. */
const bulkUpdate = ({
    accountantId, year, month, caseIds, sections = [], paymentMethod = null, followUpStatus = null,
    reportDate = null, paymentDate = null, stampReportDateIfEmpty = false, materialReceivedDate = null,
}, token) =>
    post('BulkUpdate', {
        accountantId,
        year,
        month,
        caseIds,
        sections,
        paymentMethod,
        followUpStatus,
        reportDate,
        paymentDate,
        stampReportDateIfEmpty,
        materialReceivedDate,
    }, token);

const ReportingFollowUpService = {
    getPeriodData,
    save,
    getPriorExcessDeductions,
    getNationalInsuranceSummary,
    getOverview,
    bulkUpdate,
};

export default ReportingFollowUpService;
